
import React from 'react';
import ReactDOM from 'react-dom/client';

import App from './App';
import reportWebVitals from './reportWebVitals';
import {initAuth} from "@platform/platform-auth";

const authConfiguration = {
    "clientId": process.env.REACT_APP_CLIENT_ID,
    "redirectUri": process.env.REACT_APP_OAUTH_REDIRECT_URI,
}

const root = ReactDOM.createRoot(document.getElementById('root'));
initAuth(authConfiguration).then(() => root.render(
    <React.StrictMode>
        <App/>
    </React.StrictMode>
));

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
